import { Button, Popconfirm, Tooltip } from 'antd';
import { FormInstance } from 'antd/lib';
import { useTranslation } from 'translations/hooks';

import { DefectFormValues } from 'business/quality-control/pages/record-segment-defect/components/right-panel/ring-details/defect-detail/defect-form/types';

import styles from './index.module.scss';

export const DefectFormButtons = ({
  form,
  isSubmitDisabled,
  isValidated,
  isRepairSubmitted,
  isDeleteDisabled,
  canEditDefect,
  canInvalidateDefect,
  onSave,
  onInvalidate,
  onDelete,
}: {
  form: FormInstance<DefectFormValues>;
  isSubmitDisabled: boolean;
  isValidated: boolean;
  isRepairSubmitted: boolean;
  isDeleteDisabled: boolean;
  canEditDefect: boolean;
  canInvalidateDefect: boolean;
  onSave: (values: DefectFormValues, isSubmit: boolean) => void;
  onInvalidate: () => void;
  onDelete: () => void;
}) => {
  const { t } = useTranslation();

  if (!isValidated && canEditDefect) {
    return (
      <div className={styles.buttonsFooter}>
        <Button
          type="primary"
          disabled={isSubmitDisabled}
          onClick={() => form.submit()}
        >
          {t(
            'qualityControl.recordSegmentDefect.rightPanel.defectform.cta.submit',
          )}
        </Button>
        <Button
          disabled={isSubmitDisabled}
          onClick={() => onSave(form.getFieldsValue(), false)}
        >
          {t(
            'qualityControl.recordSegmentDefect.rightPanel.defectform.cta.save',
          )}
        </Button>
        <Popconfirm
          title={t(
            'qualityControl.recordSegmentDefect.rightPanel.defectform.delete.title',
          )}
          onConfirm={onDelete}
        >
          <Button danger disabled={isDeleteDisabled}>
            {t(
              'qualityControl.recordSegmentDefect.rightPanel.defectform.cta.delete',
            )}
          </Button>
        </Popconfirm>
      </div>
    );
  }

  if (!isValidated || !canInvalidateDefect) {
    return null;
  }

  return (
    <div className={styles.buttonsFooter}>
      <Tooltip
        title={
          isRepairSubmitted
            ? t(
                'qualityControl.recordSegmentDefect.rightPanel.defectform.invalidate.disabledTooltip',
              )
            : undefined
        }
      >
        <span className={styles.invalidateTooltipWrapper}>
          <Popconfirm
            title={t(
              'qualityControl.recordSegmentDefect.rightPanel.defectform.invalidate.title',
            )}
            onConfirm={onInvalidate}
          >
            <Button danger block disabled={isRepairSubmitted}>
              {t(
                'qualityControl.recordSegmentDefect.rightPanel.defectform.cta.invalidate',
              )}
            </Button>
          </Popconfirm>
        </span>
      </Tooltip>
    </div>
  );
};
